import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LogoutComponent } from './logout.component';
import { LoadingModule } from '@organisms/loading/loading.module';

@NgModule({
  imports: [LoadingModule, RouterModule],
  declarations: [LogoutComponent],
})
export class LogoutModule {}